export default __webpack_public_path__ + "static/salon-deals~NmiTatzf-874bcd082c393842f75092c501d97e10.png";